<template>
    <div class="page-dunning-fees-and-limits">
        <DRow>
            <DCol>
                <DTabs class="mb-3">
                    <DTabItem
                        id="dunning-general"
                        :route-url="$route('settings.dunning-settings.create')"
                        :active="['settings.dunning-settings.create'].includes($route().current())"
                        :label="__('settings.dunning_settings.tabs.general')"
                    />
                    <DTabItem
                        id="dunning-fees-and-limits"
                        :route-url="$route('settings.dunning-settings.fees-and-limits.index')"
                        :active="['settings.dunning-settings.fees-and-limits.index', 'settings.dunning-settings.fees-and-limits.edit'].includes($route().current())"
                        :label="__('settings.dunning_settings.tabs.fees_and_limits')"
                    />
                </DTabs>
            </DCol>
        </DRow>
        <DCard padding>
            <DTable
                :items="items"
                :fields="[
                    {key: 'name', label: __('settings.dunning_fees_and_limits.table.headers.market_region')},
                    {key: 'currency_code', label: __('settings.dunning_fees_and_limits.table.headers.currency_code')},
                    {key: 'dunning_fees', label: __('settings.dunning_fees_and_limits.table.headers.dunning_fees')},
                    {key: 'first_dunning_fee_private', label: __('settings.dunning_fees_and_limits.table.headers.first_fee_private'), sorter: false},
                    {key: 'first_dunning_fee_business', label: __('settings.dunning_fees_and_limits.table.headers.first_fee_business'), sorter: false},
                    {key: 'second_dunning_fee_private', label: __('settings.dunning_fees_and_limits.table.headers.second_fee_private'), sorter: false},
                    {key: 'second_dunning_fee_business', label: __('settings.dunning_fees_and_limits.table.headers.second_fee_business'), sorter: false},
                    {key: 'third_dunning_fee_private', label: __('settings.dunning_fees_and_limits.table.headers.last_fee_private'), sorter: false},
                    {key: 'third_dunning_fee_business', label: __('settings.dunning_fees_and_limits.table.headers.last_fee_business'), sorter: false},
                    {key: 'mrr_dunning_threshold', label: __('settings.dunning_fees_and_limits.table.headers.mrr_dunning_threshold')},
                    {key: 'damage_compensation_fee', label: __('settings.dunning_fees_and_limits.table.headers.damage_compensation_fee')},
                    {key: 'actions', label: '', sorter: false, filter: false},
                ]"
                hover
                sorter
            >
                <template #dunning_fees="{item}">
                    <td>
                        <DBadge :color="item.dunning_fees ? 'success' : 'secondary'">
                            {{ item.dunning_fees ? __('settings.dunning_fees_and_limits.on') : __('settings.dunning_fees_and_limits.off') }}
                        </DBadge>
                    </td>
                </template>

                <template
                    v-for="field in feeFields"
                    #[field]="{item}"
                    :key="field"
                >
                    <td>
                        {{ priceFormat.numberFormatForInput(item[field] ?? 0) }}
                    </td>
                </template>

                <template #mrr_dunning_threshold="{item}">
                    <td>
                        {{ priceFormat.numberFormatForInput(item.mrr_dunning_threshold) }}
                    </td>
                </template>

                <template #damage_compensation_fee="{item}">
                    <td>
                        {{ priceFormat.numberFormatForInput(item.damage_compensation_fee ?? 0) }}
                    </td>
                </template>

                <template #actions="{item}">
                    <td>
                        <div class="actions">
                            <DButton
                                :id="`edit_${item.id}`"
                                mini
                                icon="pencil"
                                @click="editConfig(item.id)"
                            />
                        </div>
                    </td>
                </template>
            </DTable>
        </DCard>
    </div>
</template>

<script setup>
import { route } from '~@/Composables/route'
import { router } from '@inertiajs/vue3'
import { __ } from '~@/Composables/translation'
import priceFormat from '~@/Composables/priceFormat'

defineProps({
    items: {
        type: Array,
        default: () => { return [] }
    }
})

const feeFields = [
    'first_dunning_fee_private',
    'first_dunning_fee_business',
    'second_dunning_fee_private',
    'second_dunning_fee_business',
    'third_dunning_fee_private',
    'third_dunning_fee_business'
]

function editConfig (id) {
    router.get(route('settings.dunning-settings.fees-and-limits.edit', { marketRegion: id }))
}
</script>

<style lang="scss" scoped>
.page-dunning-fees-and-limits {
    display: grid;
    grid-gap: 25px;
}
.actions {
    display: flex;
    grid-gap: 10px;
    justify-content: flex-end;
}
</style>
